import { classNames } from '../../classnames/index.esm.js';
import styles from '../../../styles/uitk-egds-foundation.css';
const getClassNameList = classNames.bind(styles);
const getColorAttributes = config => {
  const themeClasses = getClassNameList(config?.color?.lightMode?.isThemeBase && !config?.color?.lightMode?.isGradient && 'uitk-light-mode-is-base', config?.color?.darkMode?.isThemeBase && !config?.color?.darkMode?.isGradient && 'uitk-dark-mode-is-base', config?.color?.lightMode?.isGradient && 'uitk-light-mode-is-gradient', config?.color?.darkMode?.isGradient && 'uitk-dark-mode-is-gradient');
  return {
    'data-theme-light': config?.color?.lightMode?.colorTheme,
    'data-theme-dark': config?.color?.darkMode?.colorTheme,
    className: themeClasses
  };
};
const getSpacingAttributes = config => ({
  'data-theme-spacing': config?.spacing?.spacingTheme
});
const getThemeAttributes = config => {
  let attributes = {};
  if (config?.color) {
    attributes = {
      ...attributes,
      ...getColorAttributes(config)
    };
  }
  if (config?.spacing) {
    attributes = {
      ...attributes,
      ...getSpacingAttributes(config)
    };
  }
  return attributes;
};
const getThemeContainerAttributes = props => {
  const {
    config
  } = props;
  let attributes = {};
  if (config?.color?.isColorThemeContainer) {
    const {
      className,
      ...attrs
    } = getColorAttributes(config);
    const containerColorClasses = {
      className: getClassNameList('uitk-theme-provider-container', className)
    };
    attributes = {
      ...attributes,
      ...attrs,
      ...containerColorClasses
    };
  }
  if (config?.spacing?.spacingTheme) {
    attributes = {
      ...attributes,
      ...getSpacingAttributes(config)
    };
  }
  return attributes;
};
export { getColorAttributes, getSpacingAttributes, getThemeAttributes, getThemeContainerAttributes };